import { updateSite } from './apis/updateSite.js';
import { filterDocumentPagesByHashes } from './utils/filterDocumentPagesByHashes.js';
import { subscribeToUpdateSiteTaskStatus } from './status.js';
import { getBase } from './apis/getBase.js';
export const deployDocument = async (document, options) => {
    const { branchId, revision, hashes } = await getBase(options.httpClient);
    const { httpClient, onStatusChange, pollInterval, timeout } = options;
    const documentUpdate = filterDocumentPagesByHashes(hashes, document);
    if (Object.keys(documentUpdate.pages).length === 0) {
        return {
            branchId,
            revision
        };
    }
    const updateSiteTaskId = await updateSite(httpClient, documentUpdate, branchId, revision);
    return subscribeToUpdateSiteTaskStatus(httpClient, updateSiteTaskId, { onStatusChange, pollInterval, timeout });
};
